/**
 * BatchGeoMobileInfoWindow component is a mobile friendly InfoWindow replacement that
 * is also compatible with the same API calls.
 *
 * @example
 *  // Shows how BatchGeoMobileInfoWindow is compatible with the InfoBox component's
 *  // API calls.
 *  var getInfoWindow = function () {
 *		if (BatchGeoDevices.is('phone')) {
 *			return BatchGeoMobileInfoWindow.init($('body'));
 *		}
 *		else {
 *			return new InfoBox({...});
 *		}
 *	};
 *
 * var infoWindow = getInfoWindow()
 * infoWindow.open();
 * infoWindow.close();
 */
(function () {
  /**
   * An alias to getting the MobileInfoWindow state.
   * @return {Object}
   */
  var getState = function () {
    return BatchGeoStore.getState().MobileInfoWindow;
  };

  /**
   * If there's a descriptionIMG field on a marker, this will give back a jQuery
   * IMG object to embed. If descriptionIMG is not there it returns undefined and
   * therefore will be ignored by jQuery.
   *
   * NOTE: This function is meant to be used with jQuery methods like append(). If
   * you do not use it with jQuery methods the click handlers will not be carried
   * over and it wont render properly!
   *
   * @param {object} marker A marker object. Must contain the textOptions property.
   * @return {jQuery|undefined}
   */
  var createMarkerImage = function (marker) {
    var options = marker.textOptions;

    // If there's a "descriptionIMG" property and its more than 0 characters then
    // we can create an image
    if (options.descriptionIMG && options.descriptionIMG.length > 0) {
      // Setup the base properties on the image
      var $img = $("<img />", {
        class: "descIMG",
        alt: options.title,
        src: options.descriptionIMG, // + '?_=' + (new Date().getTime()),
        valign: "top",
        border: 0,
      });

      // If it appears to be a streetview image we add a class and a click
      // handler to open the image in a modal
      if (options.descriptionIMG.indexOf("streetview") >= 0) {
        $img.addClass("streetview");
        $img.on("click", function () {
          BatchGeo.openStreetViewImage(
            options.title,
            encodeURI(options.address),
          );
        });
      }

      return $img;
    }
  };

  /**
   * Attaches events to the DOM that's within the state. This is private because
   * this should only be run when the DOM is changed (or else events will stack up).
   * It manages the close button handler to close the info window when you click on
   * the close button as well as handle opening/closing the infowindow when you tap
   * on it.
   *
   * @return {undefined}
   */
  var attachEvents = function () {
    var state = getState();

    state.$closeButton.on("click", function () {
      BatchGeoStore.dispatch({ type: "MOBILE_INFOWINDOW_CLOSE" });
      // The mobile infowindow will not reopen if the desktop reducer
      // still thinks the infowindow is open since it is still being tracked
      BatchGeoStore.dispatch([
        { type: "MAPSMARKERS_MANAGER_INFOWINDOW_CLOSE_VIA_X" },
        { type: "FEATURE_TOGGLE", feature: "shouldRenderTable" },
      ]);
    });

    state.$toolbar.on("click", function (event) {
      // Updating this event to only open the details window when INFO button is clicked
      if ($(event.target).hasClass("info-button")) {
        var $content = $(".batchgeo-mobile-infowindow-inner");
        $content.toggleClass("detail-open");
      }
    });
  };

  var BatchGeoMobileInfoWindow = {
    /**
     * Initializes the BatchGeoMobileInfoWindow component by creating an element
     * for the component to be rendered then triggering the init event.
     *
     * This will only run if the `initialized` state is false!
     *
     * @param {string|jQuery} container The element to append the infowindow into
     * @return {BatchGeoMobileInfoWindow}
     */
    init: function (container) {
      if (!getState().initialized) {
        var $container = $("<div />", {
          class: "batchgeo-mobile-infowindow-wrapper",
        }).appendTo(container);

        BatchGeoStore.dispatch({
          type: "MOBILE_INFOWINDOW_INIT",
          container: $container,
        });
      }

      return this;
    },
    /**
     * Triggers the MOBILE_INFOWINDOW_OPEN and if called before the DOM is fully
     * finished rendering it will call the updateDomFromMarker() function so that
     * it will prevent render errors.
     *
     * This function is really a backwards compatible way of opening the
     * infowindow. You should really call the MOBILE_INFOWINDOW_OPEN event
     * yourself and check the state yourself.
     *
     * NOTE: map is not used here but to make it compatible with the InfoBox API
     * we must have the map param here!
     *
     * @param {null} map Not used. See note above.
     * @param {google.maps.Marker} marker The Google Maps Marker to open
     * @return {undefined}
     */
    open: function (map, marker) {
      if (!getState().$dom.length) {
        this.updateDomFromMarker(marker);
      }
      var state = BatchGeoStore.getState();
      var isStoreLocatorMode = state.App.mapMode === "store_locator";
      var dataViewWasOpen = isStoreLocatorMode
        ? state.StoreLocator.visibility
        : state.BatchGeoTableMap.visibility;

      var actions = [
        {
          id: marker.id,
          type: "MAPSMARKERS_MANAGER_INFOWINDOW_OPEN",
          infoWindow: this,
          marker: marker,
        },
        {
          type: "MOBILE_INFOWINDOW_OPEN",
          marker: marker,
          dataViewWasOpen: dataViewWasOpen,
        },
      ];
      BatchGeoStore.dispatch(actions);

      window.BatchGeoInfoWindowPageEvents();
    },
    /**
     * Triggers the MOBILE_INFOWINDOW_CLOSE.
     *
     * This function is really a backwards compatible way of opening the
     * infowindow.
     *
     * NOTE: map is not used here but to make it compatible with the InfoBox API
     * we must have the map param here!
     *
     * @param {null} map Not used. See note above.
     * @param {google.maps.Marker} marker The Google Maps Marker to close
     * @return {undefined}
     */
    close: function (map, marker) {
      BatchGeoStore.dispatch({
        type: "MOBILE_INFOWINDOW_CLOSE",
        marker: marker,
      });
    },
    /**
     * Renders a marker's data within the infowindow. It renders by replacing the
     * content rather than creating a brand new one.
     *
     * @param {google.maps.Marker} marker The Google Maps Marker to close
     * @return {undefined}
     */
    updateDomFromMarker: function (marker) {
      if (!marker) return;
      var state = getState();
      var options = marker.textOptions;
      var markersData = window.batchGeoGoogleMapsManager.settings.markersData;
      var noTitle = false;
      var hasDescription = true;
      var descCount = 0;

      var $newDom = $("<div />", { class: "batchgeo-mobile-infowindow-inner" });

      $newDom.append(window.BatchGeoInfoWindowPage(marker.r));

      var $closeButton = $("<button />", {
        class: "batchgeo-mobile-infowindow-close-button",
        html: $("<span />", {
          class: "batchgeo-mobile-infowindow-close-button-x",
        }),
      }).appendTo($newDom);

      var $contentDom = $("<div />", {
        class: "batchgeo-mobile-infowindow-content",
      }).appendTo($newDom);

      // If marker has a title, display the title, if not, pull top two items from the Description
      if (options.title) {
        $contentDom.append(
          $("<h1 />", {
            html: $("<a />", {
              text: options.title,
              rel: "nofollow",
              target: "_blank",
              // FIXME: AHHH! This is very bad code. Fix this for real
              href: $(
                window.batchGeoGoogleMapsMarker.MarkerContent.createMarkerText(
                  options,
                ),
              )
                .find(".cardTitle [href]")
                .attr("href"),
              css: {
                color: "inherit",
                textDecoration: "none",
              },
            }),
          }),
        );
      } else {
        if (options.description) {
          noTitle = true;
          var htmlString = $.parseHTML(options.description);
          if (htmlString.length <= 2) {
            hasDescription = false;
          }
          var firstTwo = $(htmlString).slice(0, 2);
          var finalString;
          if (firstTwo.length === 1) {
            finalString = firstTwo[0].outerHTML;
            descCount = 1;
          } else {
            finalString = firstTwo[0].outerHTML + firstTwo[1].outerHTML;
            descCount = 2;
          }

          $contentDom.append(
            $("<div />", { html: window.linkifyHtml(finalString) }),
          );
        }
      }

      // If the phone is NOT set to be hidden we can add an address element
      if (!markersData.hideaddr_cb) {
        var rsMarker = markersData.mapRS[marker.r];
        var address = options.address;

        // If the marker address is empty but there's a lat/lng we can
        // try to geocode the real address from the lat/lng. While it's
        // geocoding we'll set the address to be the raw lat/lng
        if (
          typeof marker.addr === "string" &&
          marker.addr.trim().length === 0 &&
          rsMarker.lt
        ) {
          window.BatchGeoInfoWindowCreateAddress(marker, function (address) {
            getState().$address.html(address);
          });

          address = rsMarker.lt + "," + rsMarker.ln;
        }

        var $address = $("<address />", { html: address });
        $("<a />", {
          href: window.BatchGeoInfoWindowGenerateDirections(
            options.address,
            options,
          ),
          class: "batchgeo-mobile-infowindow-address-link",
          target: "_blank",
          html: $address,
        }).appendTo($contentDom);
      }

      if (options) {
        var hasURL = options.descriptionURL;
        var hasNav = !markersData.hideaddr_cb;
        var buttons = [];
        var buttonCount = 0;
        var hasEmail = options.email ? true : false;

        if (hasURL) {
          buttonCount++;
        }
        if (hasNav) {
          buttonCount++;
        }
        if (hasDescription) {
          buttonCount++;
        }

        var buttonColClass = "btn-col-" + buttonCount;

        if (hasDescription) {
          buttons.push(
            $("<a />", {
              class: "infowindow-footer-button info-button " + buttonColClass,
              text: "Info",
            }),
          );
        }

        if (options.descriptionURL) {
          buttons.push(
            $("<a />", {
              href:
                BatchGeo.leftSubStr(options.descriptionURL.trim(), 3) !== "htt"
                  ? "http://" + options.descriptionURL.trim()
                  : options.descriptionURL,
              target: !markersData.linkopwin_cb ? "_top" : "_blank",
              rel: "nofollow",
              class: "infowindow-footer-button url-button " + buttonColClass,
              text: "www",
            }),
          );
        }

        if (!markersData.hideaddr_cb) {
          buttons.push(
            $("<a />", {
              href: window.BatchGeoInfoWindowGenerateDirections(
                options.address,
                options,
              ),
              class: "infowindow-footer-button nav-button " + buttonColClass,
              target: "_blank",
              text: "Nav",
            }),
          );
        }

        var $infoWindowFooter;
        if (buttons.length > 0) {
          $infoWindowFooter = $("<div />", {
            class: "batchgeo-mobile-infowindow-footer",
          }).append(buttons);
        } else {
          $infoWindowFooter = $("<div />", {
            class: "batchgeo-mobile-no-infowindow-footer",
          });
        }
      }

      var $markerContent;
      if (hasDescription) {
        if (noTitle) {
          var descriptionString = $.parseHTML(options.description);
          var filteredDescription = $(descriptionString).slice(
            descCount,
            descriptionString.length,
          );

          var formattedDescription = "";
          for (var i = 0; i < filteredDescription.length; i++) {
            formattedDescription += filteredDescription[i].outerHTML;
          }

          $markerContent = $("<div />", {
            class: "batchgeo-mobile-infowindow-content-inner",
            // Make sure that if any links are in the description they are linked
            html: window.linkifyHtml(formattedDescription),
          }).appendTo($newDom);
        } else if (hasEmail) {
          $markerContent = $("<div />", {
            class: "batchgeo-mobile-infowindow-content-inner",
            // Make sure that if any links are in the description they are linked
            html: `${window.linkifyHtml(options.description)}<div><span class="l">Email:</span>&nbsp;<a href="mailto:${options.email}">${options.email}</a></div>`,
          }).appendTo($newDom);
        } else {
          $markerContent = $("<div />", {
            class: "batchgeo-mobile-infowindow-content-inner",
            // Make sure that if any links are in the description they are linked
            html: `${window.linkifyHtml(options.description)}`,
          }).appendTo($newDom);
        }
      } else {
        $markerContent = $("<div />", {
          class: "batchgeo-mobile-infowindow-content-inner",
        }).appendTo($newDom);
      }

      // Add the marker image. Since the function will return undefined if no
      // image exists for the marker than it's safe to just pass it to jQuery's
      // append because it will ignore falsy values.
      $markerContent.append(createMarkerImage(marker));

      $newDom.toggleClass("batchgeo-mobile-infowindow-show", state.showDetails);
      $newDom.toggleClass("batchgeo-mobile-infowindow-open", state.open);
      $newDom.toggleClass(
        "ios-iframe",
        BatchGeoDevices.is("ios") && BatchGeo.iframeDetect(),
      );
      $newDom.toggleClass("animate", state.showDetails);

      $(state.container).empty().append($newDom);
      if ($infoWindowFooter) {
        $(state.container).append($infoWindowFooter);
      }

      // Hide toolbar when InfoWindow is hidden
      $infoWindowFooter.toggleClass("info-window-footer-show", state.open);

      // We need to make sure that if it's iOS that it's NOT in an iframe
      // because the iframe will keep expanding each time this is run.
      // That's because iOS will resize the iframe window to fit the
      // content in the iframe and we're pushing the mobile info window
      // below the visible area so it tries to resize to show it.
      if (!BatchGeoDevices.is("ios") || !BatchGeo.iframeDetect()) {
        // Default value to hide info window until image has loaded/resolved
        $newDom.css({
          bottom: -9999,
        });
        if (hasDescription) {
          if ($(".descIMG").length) {
            $(".descIMG").on("load", function () {
              $newDom.css({
                bottom: -$markerContent.outerHeight() + 35,
              });
            });
          } else {
            $newDom.css({
              bottom: -$markerContent.outerHeight() + 35,
            });
          }
        } else {
          $newDom.css({
            bottom: 0,
          });
        }
      }

      // Save all the new DOM that was created
      BatchGeoStore.dispatch({
        type: "MOBILE_INFOWINDOW_SAVE_DOM",
        $dom: $newDom,
        $closeButton: $closeButton,
        $address: $address,
        $toolbar: $infoWindowFooter,
      });

      // Add the events to the DOM
      attachEvents();
    },
    /**
     * Called when the status of getState().MobileInfoWindow.open changes
     * @param {*} newState MobileInfoWindow reducer state
     */
    onMobileInfoWindowOpenChange: function (newState) {
      var isOpen = newState.open;
      var isStoreLocatorMode =
        BatchGeoStore.getState().App.mapMode === "store_locator";
      var type = isStoreLocatorMode
        ? "STORE_LOCATOR_VISIBILITY"
        : "TABLE_MAP_VISIBILITY";

      if (!isOpen) {
        // Remove necessary classes
        newState.$dom.addClass("animate");
        newState.$toolbar.removeClass("info-window-footer-show");

        // If when we created the infowindow and a dataview (locator / table) was opened
        // then open it again. Ex. Clicking directly on a marker, then hitting the X wouldn't
        // trigger this.
        if (newState.dataViewWasOpen) {
          BatchGeoStore.dispatch({ type: type, visibility: true });
        }
      } else if (newState.dataViewWasOpen) {
        // If we are opening a marker and the data view is open, then close it
        BatchGeoStore.dispatch({ type: type, visibility: false });
      }

      newState.$dom.toggleClass("batchgeo-mobile-infowindow-open", isOpen);
      window.batchGeoMap.bgSize(true, isOpen);
    },
  };

  /**
   * When showDetails changes we want to toggle the show class
   */
  BatchGeoStore.addListener(
    "MobileInfoWindow",
    "showDetails",
    function (newState) {
      newState.$dom.toggleClass(
        "batchgeo-mobile-infowindow-show",
        newState.showDetails,
      );
    },
  );

  /**
   * When open changes we toggle the open class and update the state. We also call
   * bgSize again because when the visibility changes other components may show and
   * hide themselves which can affect the sizing.
   */
  BatchGeoStore.addListener(
    "MobileInfoWindow",
    "open",
    BatchGeoMobileInfoWindow.onMobileInfoWindowOpenChange,
  );

  BatchGeoStore.addListener(
    "MobileInfoWindow",
    "marker",
    function (newState, prevState) {
      if (newState.marker && prevState.marker) {
        var newPosition = newState.marker.position;
        var prevPosition = prevState.marker.position;
        if (
          BatchGeo.distance2(
            newPosition.lat(),
            newPosition.lng(),
            prevPosition.lat(),
            prevPosition.lng(),
          ) >= 0.0001
        ) {
          BatchGeoStore.dispatch({
            type: "MAPSMARKERS_MANAGER_MARKER_PAGINATE_RESET",
          });
        }
      }
    },
  );

  /**
   * Change the marker contents when the current marker changes in the state.
   */
  BatchGeoStore.addListener(
    "MobileInfoWindow",
    "marker",
    function (newState, _prevState) {
      BatchGeoMobileInfoWindow.updateDomFromMarker(newState.marker);
    },
  );

  window.BatchGeoMobileInfoWindow = BatchGeoMobileInfoWindow;
})();
